/** Brand palette — keep in sync with `tailwind.config.js` → `theme.extend.colors.brand` */
export const BRAND_PRIMARY = '#64247F';
